import React, { useState } from 'react';
import EntityLabelsModal from './EntityLabelsModal';
import { IconLabel, iconBtnStyle } from '../../shared/icons/IconLib';
import { formatItemLabelsSummary, getItemLabels } from '../../shared/utils/entityLabelFilter';

/**
 * Table cell: label icon (like time-filter affordance) opens modal to pick / manage labels.
 */
export default function EntityLabelCell({
  item,
  labelOptions = [],
  disabled = false,
  saving = false,
  onApplyLabels,
  onAddLabel,
  onRenameLabel,
  onRemoveLabel,
  setConfirmDialog,
  ariaLabel = 'Labels',
  /** Icon only — label names shown in tooltip (e.g. inside row action icons). */
  iconOnly = false,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const itemLabels = getItemLabels(item);
  const summary = formatItemLabelsSummary(item);
  const hasLabels = itemLabels.length > 0;
  const tooltip = hasLabels ? summary : 'Assign labels';
  const buttonAriaLabel = hasLabels ? `${ariaLabel}: ${summary}` : ariaLabel;

  const labelButton = (
    <button
      type="button"
      className={`btn-link entity-label-cell__btn${iconOnly ? ' entity-label-cell__btn--icon-only' : ''}${hasLabels ? ' entity-label-cell__btn--active' : ''}`}
      style={iconBtnStyle}
      title={tooltip}
      aria-label={buttonAriaLabel}
      disabled={disabled || saving}
      onClick={() => setModalOpen(true)}
    >
      <IconLabel size={18} />
    </button>
  );

  return (
    <>
      {iconOnly ? (
        labelButton
      ) : (
        <div className="entity-label-cell">
          {labelButton}
          {hasLabels ? (
            <span className="entity-label-cell__summary" title={summary}>
              {summary}
            </span>
          ) : null}
        </div>
      )}
      <EntityLabelsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        labelOptions={labelOptions}
        selectedLabels={itemLabels}
        onApplyLabels={onApplyLabels}
        onAddLabel={onAddLabel}
        onRenameLabel={onRenameLabel}
        onRemoveLabel={onRemoveLabel}
        setConfirmDialog={setConfirmDialog}
        saving={saving}
      />
    </>
  );
}
